const ApplicationLogo = ({className}) => {
    return (
        <img className={className} src="/storage/images/whm-logo.png" alt="Logo" />
    );
}

export default ApplicationLogo;